interface IFileSelectDirectiveScope extends ng.IScope {
    onFilesSelected: ({ $files: File }) => void;
}

export function FileInputDirective(): ng.IDirective {
    return {
        link: function postLink(scope: IFileSelectDirectiveScope,element: JQuery<HTMLInputElement>) {
            if (!(element[0] instanceof HTMLInputElement)) {
                throw new Error("FileInputDirective must be applied to HTMLInputElement");
            }
            element.attr("type", "file");
            element.bind({
                change: (e: JQuery.ChangeEvent<
                    HTMLInputElement,
                    undefined,
                    HTMLInputElement,
                    HTMLInputElement
                >) => {
                    const files = e.target.files;
                    if (files) {
                        scope.onFilesSelected({ $files: files });
                    }
                },
            });
        },
        restrict: "A",
        scope: {
            onFilesSelected: "&",
        },
    }
}
